import React from "react";
import PropTypes from "prop-types";
import { Input } from "reactstrap";

/**
 * 列表工具列的狀態下拉（design system primitive;票 30 收口）。
 *
 * 走模板 `/form-elements` 的 select(reactstrap `<Input type="select">` → `.form-select`),
 * 跟表單裡有 label 外殼的 `SelectField` 是兩種東西 —— 這顆是工具列上緊貼查詢框的
 * 單一篩選,沒有可見標籤,靠 `aria-label` 當無障礙名稱(頁面測試都用它找元素)。
 * 不只狀態:`allLabel`／`ariaLabel` 換掉就是別種篩選(審核中心的「全部類型」,票 34)。
 * 抽出來的理由:機房／機櫃／硬體／角色／審核中心本來各寫一份一模一樣的
 * `<Input type="select" style={{ width: 140 }} aria-label="狀態">`,而功能頁的匿名
 * inline style 是 CLAUDE.md 禁止的;寬度收成 `.dck-status-select`(_dck-figma.scss)。
 *
 *   <StatusFilterSelect value={v} onChange={setV} options={["啟用中", "停用"]} />
 *   <StatusFilterSelect value={v} onChange={setV}
 *     options={[{ value: "pending", label: "審核中" }]} />   // 值與文字不同時
 */
const normalize = (o) => (typeof o === "string" ? { value: o, label: o } : o);

export const StatusFilterSelect = ({
  value = "", onChange, options = [], allLabel = "全部狀態", ariaLabel = "狀態", wide = false, className = "", ...rest
}) => (
  // rest 先展開:aria-label 只能走 ariaLabel 換,免得呼叫端一個 aria-label 把測試靠的名稱蓋掉
  <Input
    {...rest}
    type="select"
    className={["dck-status-select", wide ? "dck-status-select-wide" : "", className].filter(Boolean).join(" ")}
    aria-label={ariaLabel}
    value={value}
    onChange={(e) => onChange && onChange(e.target.value, e)}
  >
    <option value="">{allLabel}</option>
    {options.map(normalize).map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
  </Input>
);
StatusFilterSelect.propTypes = {
  value: PropTypes.string,
  /** 回選到的值(字串);第二參數是原生事件 */
  onChange: PropTypes.func,
  /** 字串陣列(值＝文字)或 `{ value, label }` */
  options: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ value: PropTypes.string.isRequired, label: PropTypes.node.isRequired }),
  ])),
  /** 第一個(空值)選項的文字 */
  allLabel: PropTypes.string,
  /** 無障礙名稱(沒有可見標籤,別跟 SelectField 的 label 混);預設「狀態」 */
  ariaLabel: PropTypes.string,
  /** 寬版(160;審核中心的類型下拉,票 34)。具名變體,不開數字 width */
  wide: PropTypes.bool,
  className: PropTypes.string,
};

export default StatusFilterSelect;
